import { Component } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Subscription } from 'rxjs';

import { CommonService, Destroy, NotFoundComponent, SnackService, ToastService } from '@increff/commons';
import { ConfigService } from './common/services/config.service';
import { LandingComponent } from './components/landing/landing.component';

@Component({
    selector: 'com-root',
    templateUrl: './app.html',
    styleUrls: ['./app.scss'],
    viewProviders: [Destroy]
})

export class AppComponent {

    proSidebarPresent: boolean;
    siblingRoutesPresent: boolean;
    pageHeadSubscription: Subscription;

    constructor(
        private locationStrategy: LocationStrategy,
        private snackService: SnackService,
        private toastService: ToastService,
        public configService: ConfigService,
        public commonService: CommonService,
    ) {
        let elements;
        this.locationStrategy.onPopState(() => {
            this.snackService.clear();
            this.toastService.clear();
            elements = document.getElementsByClassName('modal-backdrop');
            while (elements.length > 0)
                elements[0].parentNode.removeChild(elements[0]);
        });
        elements = document.getElementsByClassName('modal-backdrop');
        while (elements.length > 0)
            elements[0].parentNode.removeChild(elements[0]);
    }

    ngOnInit() {
        this.pageHeadSubscription = this.configService.pageHeader.subscribe(pageHeader => {
            this.configService.setPageTitle(pageHeader);
        });
    }

    ngAfterViewInit() {
        this.commonService.initTooltip('com-root');
    }

    isSiblingRoutePresent($event: boolean) {
        this.siblingRoutesPresent = $event;
    }

    isProSidebarPresent($event: boolean) {
        this.proSidebarPresent = $event;
    }

    ngOnDestroy() {
        this.pageHeadSubscription.unsubscribe();
    }

    onActivate(routeEvent) {
        if(routeEvent?.constructor !== LandingComponent && routeEvent?.contructor !== NotFoundComponent) localStorage?.removeItem('captchaRefreshObj');
    }

    onDeactivate() {
        this.snackService.clear();
        this.toastService.clear();
        this.configService.pageHeaderExtraTemplateRef= null;
    }
}
